import { Component } from '@angular/core';

@Component({
  selector: 'app-catalogue-document-types',
  templateUrl: './catalogue-document-types.component.html'
})
export class CatalogueDocumentTypesComponent {}
